import React from 'react';
import DeviceScanCard from '../../../../components/DeviceScan/DeviceScanCard';
import useDeviceScanSession from '../../../../components/DeviceScan/useDeviceScanSession';

function DeviceScan(props) {
    const { transaction } = props;
    const { deviceScan, sdkMetadata } = useDeviceScanSession(
        transaction.event_data?.company_key,
        transaction.event_data?.source?.session_id
    );

    return (
        <DeviceScanCard
            deviceScan={deviceScan}
            channel={transaction.event_data?.source?.channel}
            sdkMetadata={sdkMetadata}
        />
    );
}

export default DeviceScan;
